import {
  UPDATE_FIREBASE_PROFILE,
  RESET_PROFILE_AUTH,
  UPDATE_FIREBASE_AUTH,
  PROFILE_LOADING,
} from "../actions/types"

const INITIAL_STATE = {
  profile: {
    isLoaded: false,
    isEmpty: true,
  },
  auth: {
    isLoaded: false,
    isEmpty: true,
  },
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PROFILE_LOADING:
      return {
        ...state,
        profile: {
          isLoaded: false,
          isEmpty: true,
        },
      }
    case UPDATE_FIREBASE_PROFILE:
      return {
        ...state,
        profile: {
          ...action.payload,
          isEmpty: !action.payload,
          isLoaded: true,
        },
      }
    case UPDATE_FIREBASE_AUTH:
      return {
        ...state,
        auth: {
          ...action.payload,
          isEmpty: !action.payload,
          isLoaded: true,
        },
      }
    case RESET_PROFILE_AUTH:
      return {
        profile: {
          isLoaded: true,
          isEmpty: true,
        },
        auth: {
          isLoaded: true,
          isEmpty: true,
        },
      }
    default:
      return state
  }
}
